import { connect } from 'react-redux';

import { BuilderCallHelperPopup, IBuilderCallHelperPopupProps } from '../../components/BuilderCallHelperPopup';
import { IState } from '../../store';
import { trackCallBuilderPopupCadastreLinkClick, trackShowCallBuilderPopup } from '../../store/tracking';
import { trackingPhoneEvent } from '../../store/tracking/mobile';
import { TTypedThunkDispatch } from '../../types/store';

type TStoreProps = Pick<IBuilderCallHelperPopupProps, 'phone' | 'workTime'>;
type TDispatchProps = Pick<IBuilderCallHelperPopupProps, 'onInit' | 'onShowPhone' | 'onCadastreLinkClick'>;

export function mapStateToProps(state: IState): TStoreProps {
  const { builder } = state.villageData.village;

  return builder
    ? {
        phone: builder.displayPhone ? builder.phone : undefined,
        workTime: builder.workTime,
      }
    : {};
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): TDispatchProps {
  return {
    onInit() {
      dispatch(trackShowCallBuilderPopup());
    },
    onShowPhone() {
      dispatch(trackingPhoneEvent('Open_KP_card_blockKP_popup'));
    },
    onCadastreLinkClick(url: string) {
      dispatch(trackCallBuilderPopupCadastreLinkClick(url));
    },
  };
}

export const BuilderCallHelperPopupContainer = connect<TStoreProps, TDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(BuilderCallHelperPopup);
